export default __webpack_public_path__ + "static/media/night-light.ac0285f2.jpg";